import { Pipe, PipeTransform } from '@angular/core';
import { DealStatusModel } from '../_models/_index';
import { DealStatusService } from '../services/deal-status.service';


@Pipe({
    name: 'dealStatus',
    pure: false
})
export class DealStatusPipe implements PipeTransform {
    dealStatuses: DealStatusModel[];

    constructor(private dealStatusService: DealStatusService) {
        this.dealStatusService.getDealStatuses().then((list: DealStatusModel[]) => {
            this.dealStatuses = list;
        });
    }

    transform(value: any, args?: any): any {
        if (value && this.dealStatuses) {
            var status = this.dealStatuses.find(b => b.id == value);
            if (status) {
                return status.description;
            }
        }
        else {
            return "";
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/_pipes/deal-status.pipe.ts